<template>
    <div class="flex items-center gap-1">
        <div class="relative" role="img" :aria-label="`Rating ${rating ?? 0} out of 5 stars`">
            <div class="flex text-ash-300">
                <Icon v-for="_ of MAX_STARS" icon='star' aria-hidden="true" />
            </div>
            <div class="flex absolute top-0 left-0 text-ash-500">
                <Icon v-for="_ of fullStars" icon='star' aria-hidden="true" />
                <Icon v-if="hasHalfStar" icon='star-half' aria-hidden="true" />
            </div>
        </div>
        <div class="text-ash-100">
            {{ `(${rating ?? 0}/5)` }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Icon from '../atom/icon.vue';

const MAX_STARS = 5;

interface StarRatingProps {
    rating: number;
}

const props = defineProps<StarRatingProps>();

const fullStars = computed(() => Math.min(Math.floor(props.rating), MAX_STARS));
const hasHalfStar = computed(() => props.rating % 1 >= 0.5);

</script>